export const getParsedAppointments = (data: any[]) => {
  return data?.map((x: any) => ({
    id: x?.id,
    value: x?.integration_id,
    label: x?.label,
    integrationId: x?.integration_id,
    description: x?.description,
  }));
};

export const getPayload = (
  formValues: any,
  selectedPets: any,
  selectedClientAccount: any,
  provider?: any
) => {
  return {
    provider: provider?.actor_id,
    client: {
      id: selectedClientAccount?.id,
      integration_id: selectedClientAccount?.integration_id,
    },
    patients: selectedPets?.map((x: any) => {
      const appointmentTypeIntegrationId =
        formValues?.[`appointment_type_${x?.id}`];

      return {
        appointmentType: {
          integration_id: appointmentTypeIntegrationId,
        },
        clientReason: formValues?.[`reason_${x?.id}`],
        integration_id: selectedClientAccount?.integration_id,
      };
    }),
  };
};